<template>
    <z-backForm :name="'back-budget-auto'" :align="true" :btns="showflag" @save="saveSet" @cancel="backset">
        <!-- BU名称 -->
        <div class="back-item">
            <div class="back-title">BU名称 </div>
            <div class="back-wrap">
                <el-select class="top-choose z-mid" v-model="bu_id" placeholder="请选择" @change="getData">
                    <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                    </z-limitOption>
                </el-select>
            </div>
        </div>

        <div class="small-title"></div>

        <!-- 检测完成率 -->
        <div class="back-item first">
            <div class="back-title">检测完成率</div>
            <div class="back-wrap">
                <el-switch v-model="rate_flag"  on-text="" off-text="">
                </el-switch>
                <div class="tip">开启后每月将检查预算完成率，如未达标则开具罚单</div>
            </div>
        </div>
        <!-- 预算完成率 -->
        <transition name="fade">
            <div class="back-item" v-show="rate_flag">
                <div class="back-title">预算完成率</div>
                <div class="back-wrap">
                    <el-select class="top-choose z-mid" v-tar="sub.min_rate" v-model="sub.min_rate" placeholder="请选择">
                        <el-option v-for="item in complete_options" :key="item" :value="item" :label="`${item}%`">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </transition>


        <!-- 自动充值 -->
        <div class="back-item">
            <div class="back-title">自动充值</div>
            <div class="back-wrap">
                <el-switch v-model="auto_flag"  on-text="" off-text="">
                </el-switch>
                <div class="tip">开启后每月将对该BU进行固定充值</div>
            </div>
        </div>

        <!-- 充值金额 -->
        <div class="back-item" v-show="auto_flag">
            <div class="back-title">充值金额</div>
            <div class="back-wrap">
                <el-input class="top-choose z-mid" rule="noVal number positive" v-tar="sub.auto_amount" v-model="sub.auto_amount" placeholder="请输入充值金额">
                    <template slot="append">币</template>
                </el-input>
            </div>
        </div>

        <!-- 循环设置 -->
        <div class="back-item" v-show="auto_flag">
            <div class="back-title">循环设置</div>
            <div class="back-wrap text">
                每月
                <!-- <el-select class="top-choose z-mid" rule="noVal" v-tar="sub[1]" v-model="sub[1]" placeholder="请选择">
                    <el-option v-for="item in canCurrency" :key="item.id" :value="item.id" :label="item.currency_name">
                    </el-option>
                </el-select> -->
            </div>
        </div>
        
        
    </z-backForm>

</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        data(){
            return {
                bu_list:[],   //bu列表
                bu_id:"",    //bu id

                sub:{
                    min_rate:0,
                    auto_amount:0,
                },

                //固定参数
                typeArr:[
                    {
                        val:1,
                        label:"预算充值",
                    },
                    {
                        val:2,
                        label:"预算扣除",
                    },
                ],
                complete_options:[10,20,30,40,50,60,70,80,90],

            }
        },
        computed:{
            showflag(){
                return this.bu_id != "";
            },
            rate_flag:{   //完成率检测
                get(){
                    return this.sub.min_rate != 0?true:false;
                },
                set(val){
                    if(val){
                        this.sub.min_rate = 10;
                    }else{
                        this.sub.min_rate = 0;
                    }
                }
            },
            auto_flag:{   //自动充值
                get(){
                    return this.sub.auto_amount !== 0?true:false;
                },
                set(val){
                    if(val){
                        this.sub.auto_amount = "";
                    }else{
                        this.sub.auto_amount = 0;
                        this.$form.clear('back-budget-auto');
                    }
                }
            },

        },
        created(){
            this.$func.getBuList(true,list=>{
                this.bu_list = list;
                this.bu_id = this.$crypto.decrypt(this.$route.params.id);
            });
        },

        // beforeRouteLeave(to,from,next){  //离开页面之前
        //     console.log("enheng");
		// 	let res = this.$form.leave({name:'back-budget-auto',path:to.path});
		// 	next(res);
        // },
        
        methods:{
            getData(id){
                let url = `api/admin/get_bu/${id || this.bu_id}`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.sub.min_rate = res.res_data.bgtUseMinRatio;
                        this.sub.auto_amount = res.res_data.bgtAmount;
                        this.$form.init('back-budget-auto');
                    }
                });
            },
            saveSet(){  //保存
                let url = `api/admin/set_bgt_amount/${this.bu_id}`;
                let obj = {
                    bgt_amount:this.sub.auto_amount,
                    bgt_use_min_ratio:this.sub.min_rate,
                }
                this.$func.loading(true);
                this.$http.post(url,obj).then(res=>{
                    if(res.status == 200){
                        this.getData();
                        this.successTip("设置成功");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("设置失败");
                    this.$func.loading(false);
                });

            },
            backset(dataArr){  //取消
                this.getData();
            }

        },
    }
</script>

<style lang="less" scoped>
    .hide-wrap{
        display: inline-block;
    }

    .first{
        &:before{
            content:"";
            display: block;
            // margin-bottom: 25px;
            height:25px;
        }
        .back-wrap{
            top:25px !important;
        }
    }

    // .small-title{
    //     // margin-bottom: 25px;
    //     &:after{
    //         content:"";
    //         display: block;
    //         margin-bottom: 25px;
    //     }
    // }

</style>





// WEBPACK FOOTER //
// budget-auto.vue?38149cee